import FlashLib from "flashlib";

export default class BaseBetProgressContainer extends FlashLib.MovieClip {
    constructor(data, displayItemData) {
        super(data, displayItemData);

        this.incativeTintColor = 0xCCCCCC;
        this._enabled = false;

        this.init();
    }

    init() {
        this.progress = this.getChildAt(0);
    }

    setRange(valuesRange) {
        this.valuesRange = valuesRange;
        this.oneStepWidth = 170 / (this.valuesRange.length - 1);
    }

    setValue(value) {
        let index = this.valuesRange.indexOf(value);
        this.progress.width = this.oneStepWidth * index;
    }

    set enabled(value) {
        this._enabled = value;
        this.children.forEach((child)=>{
            child.tint = this._enabled ? 16777215 : this.incativeTintColor;
        });
    }
}